export default __webpack_public_path__ + "static/media/1567.461ba92a.png";